import { ActivityDestinationViewSearch } from '../common/__generated__/api';

const IS_PREFIX = 'things-to-do';
const SUFFIX = 'activity-details';

function getActivityTitle(activityName: string): string {
  if (!activityName) {
    return 'm';
  }
  const matchNonAlphaNumericOrSpace = /[^a-zA-Z0-9_\-\s]+/g;

  return activityName.replace(matchNonAlphaNumericOrSpace, '').replace(/\s+/g, '-');
}

export function completeISUrl(
  activity: ActivityDestinationViewSearch.ActivityInlineFragment,
  search: string,
  swpApplied?: boolean,
  recommendedActvityIndex?: number,
  isRecommendationTile?: boolean,
  mctcValue?: number
): string {
  const referrerId = activity.analytics ? activity.analytics.referrerId : '';
  const swpString = swpApplied ? '&swp=on' : '&swp=off';
  const rfrrString = isRecommendationTile ? `&rfrr=${referrerId}` : '';
  const mctcString = mctcValue ? `&mctc=${mctcValue}` : '';

  return `/${IS_PREFIX}/${getActivityTitle(activity.name)}.a${
    activity.id
  }.${SUFFIX}${search}${swpString}${rfrrString}${mctcString}`;
}
